import React from 'react'
import { storiesOf } from '@storybook/react'
import { Grid, Fab } from '@material-ui/core'
import Button from '../components/Button'

storiesOf('Essentials/Button', module)
  .add('color variants', () => (
    <Grid container direction="column" spacing={2}>
      <Grid item>
        <Button>Default Button</Button>
      </Grid>

      <Grid item>
        <Button color="primary">Primary Button</Button>
      </Grid>
      <Grid item>
        <Button variant="contained" color="primary">Contained Primary Button</Button>
      </Grid>

      <Grid item>
        <Button color="secondary">Secondary Button</Button>
      </Grid>
      <Grid item>
        <Button variant="contained" color="secondary">Contained Secondary Button</Button>
      </Grid>
      <Grid item>
        <Button color="dangerous">Dangerous Button</Button>
      </Grid>
      <Grid item>
        <Button variant="contained" color="dangerous">Contained Dangerous Button</Button>
      </Grid>

      <Grid item>
        <Button color="accent">Accent Button</Button>
      </Grid>
      <Grid item>
        <Button variant="contained" color="accent">Contained Accent Button</Button>
      </Grid>

    </Grid>
  ))
